"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgStarEmpty = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M12.482 5.306l1.457 4.796a.5.5 0 00.491.408h4.45a.498.498 0 01.288.905l-3.639 2.598a.5.5 0 00-.187.555l1.43 4.61h0c.145.463-.393.84-.778.545h-.001l-3.69-2.81a.5.5 0 00-.605-.001l-3.69 2.8-.002.001c-.385.295-.923-.082-.779-.544h0l1.43-4.61a.5.5 0 00-.186-.556l-3.64-2.6h-.002c-.39-.277-.195-.903.291-.903h4.45a.5.5 0 00.478-.354l1.48-4.84h0l.002-.005a.496.496 0 01.952.005z", strokeLinejoin: "round" }) }))); };
exports.default = SvgStarEmpty;
